import { RSAA } from 'redux-api-middleware';

const KNOWN_ENV_PREFIXES = [ '/test', '/staging', '/dev' ];

export default store => next => action => {
    const rsaa = action[ RSAA ] || null;

    try {
        if(rsaa != null) {
            let
            isPrefixed = undefined,
            path = window.location.pathname;

            KNOWN_ENV_PREFIXES.forEach(prefix => { if(path.startsWith(prefix)) isPrefixed = prefix; });

            if(isPrefixed) {
                if(rsaa.endpoint.startsWith('/')) rsaa.endpoint = `${isPrefixed}${rsaa.endpoint}`;
                else rsaa.endpoint = `${isPrefixed}/${rsaa.endpoint}`;
            }
        }
    } catch(error) {
    }

    return next(action);
}
